import { toZonedTime } from 'date-fns-tz'

export const PRAGUE_TZ = 'Europe/Prague'

type FakeState = {
  origin: number
  base: number
  speed: number
}

let fake: FakeState | null = null

export function realNow(): Date {
  return new Date()
}

export function now(): Date {
  if (!fake) return new Date()
  const elapsed = Date.now() - fake.origin
  return new Date(fake.base + elapsed * fake.speed)
}

export function setFakeClock(at: Date | string, speed = 1): void {
  fake = {
    origin: Date.now(),
    base: typeof at === 'string' ? new Date(at).getTime() : at.getTime(),
    speed,
  }
}

export function clearFakeClock(): void {
  fake = null
}

export function isFakeActive(): boolean {
  return fake !== null
}

export function nowInPrague(): Date {
  return toZonedTime(now(), PRAGUE_TZ)
}

export function bootClockFromUrl(): void {
  if (typeof window === 'undefined') return
  const params = new URLSearchParams(window.location.search)
  const at = params.get('clock')
  const speed = Number(params.get('speed') ?? '1')
  if (at) setFakeClock(at, isFinite(speed) && speed > 0 ? speed : 1)
}
